import React, { useState, useEffect, useRef, useContext } from 'react';

import { Button } from 'web-store-modules/packages/web-store-ui-library';
import FlyUpModal from '../FlyUpModal';
import { getFontStylesAsync } from '../../../../utils/StoreConfigManager';
import './TextModal.css';
import './ExhibitTextModal.css';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import { constructUrl } from '../../../../utils/UrlConstructor';
import { AppContext } from "../../../../AppContext.jsx";
import { TextPopUpButtonClicked } from "../../../../utils/Analytics";
import ModalOverlay from '../ModalOverlay';
import ReactHtmlParser from "react-html-parser";
import { getTrackingParameter } from '../../../../utils/StoreConfigManager';

const isMobile = isMobileDevice();

const ExhibitTextModal = ({ modalContent, onModalHidden, onClose, primaryColor, secondaryColor }) => {
    const { title, sub_title, body, button_copy, button_url, url } = modalContent;
    const [fontStyles, setFontStyles] = useState();
    const [modalActive, setModalActive] = useState();
    const modalRef = useRef();
    const { currentSceneName } = useContext(AppContext);

    useEffect(() => {
        fetchFontStyles();
        addListeners();
        return (() => {
            removeListeners();
        });

    }, []);

    const addListeners = () => {
        if (isMobile) {
            window.addEventListener('touchend', handleModalClose);
        } else {
            window.addEventListener('click', handleModalClose);
        }
    }

    const removeListeners = () => {
        if (isMobile) {
            window.removeEventListener('touchend', handleModalClose);
        } else {
            window.removeEventListener('click', handleModalClose);
        }
    }

    const fetchFontStyles = () => {
        getFontStylesAsync()
            .then((fontStyles) => setFontStyles(fontStyles))
            .catch((err) => console.error(err));

    }

    const handleModalClose = (e) => {
        if (modalRef && modalRef.current.contains(e.target)) {
            return;
        }
        closeModal();
    }

    const closeModal = () => {
        if (onClose) {
            setModalActive(false);
            onClose();
        }
    }

    const handleClick = () => {
        TextPopUpButtonClicked(currentSceneName);
        const attRedirectPath = constructUrl(button_url);
        const trackingParam = getTrackingParameter();
        const trackingParamUrl = `${attRedirectPath}?${trackingParam}`

        window.open(trackingParamUrl, '_blank');
    }

    const productButton = () => {
        return (
            <div className="product-button-container">
                <Button
                    hoverStyleChange={false}
                    onClick={handleClick}
                    primaryColor={"#000000"}
                    secondaryColor={secondaryColor}
                    className="text-marker-button flex-center obsessvr-regularFont full-width pointer product-button"
                    style={{ padding: '0', margin: '0 1%', borderRadius: '0px' }}
                    primaryBorderColor='white'
                    secondaryBorderColor='white'
                    primaryBorderWidth='0px'
                    secondaryBorderWidth='0px'
                    insetBorder={true}
                    padded={false}
                >
                    <span className="obsessvr-regularFont" style={{ color: "red", fontWeight: 700, fontSize: '14px' }}>
                        {button_copy}
                    </span>

                </Button></div>
        )
    }

    const textContainer = () => {
        return (
            <div className='exhibit-text-modal-text-container'>
                <pre
                    style={{
                        fontSize: isMobile ? '16px' : '20px',
                        fontFamily: 'NeueHaasDisplayThin',
                        whiteSpace: 'pre-wrap',
                        marginTop: '0'
                    }}
                >
                    {ReactHtmlParser(body)}
                </pre>
            </div>
        )
    }

    const titleRender = () => {
        return (
            <div className='exhibit-text-modal-title-container'>
                <span
                    style={{
                        fontSize: isMobile ? '22px' : '35px',
                        fontFamily: 'NHaasGroteskTXPro-75Bd'
                    }}>
                    {title}
                </span>
            </div>
        );
    }

    const subtitleRender = () => {
        return (
            <div className='exhibit-text-modal-subtitle-container'>
                <span
                    style={{
                        fontSize: isMobile ? '18px' : '25px',
                        fontFamily: 'NHaasGroteskTXPro-55Rg'
                    }}>
                    {sub_title}
                </span>
            </div>
        );
    }

    const imageRender = () => {
        const imageUrl = constructUrl(url);
        return (
            <div className="zoomedImageWrapper">
                <div className="zoomedImageContainer flex-center">
                    <img src={imageUrl} style={{ maxWidth: '100%', maxHeight: isMobile ? '300px' : 'auto' }} />
                </div>
            </div>

        );
    }

    const renderModalContent = () => {
        return (
            <div className='exhibit-text-modal-content' style={{ textAlign: 'center' }} ref={modalRef}>
                <div className='exhibit-left-section'> 
                    {url && imageRender()}
                </div>
                <div className='exhibit-right-section'>
                    {titleRender()}
                    {subtitleRender()}
                    {textContainer()}
                    {button_copy && productButton()}
                </div>
            </div>
        )
    }
    return (
        //Added the isImage Loaded bool here to display the close button on the Modal due to a condition in Modal.jsx
        <FlyUpModal extraClassName="exhibit-text-modal-container" onModalHidden={onModalHidden} isOpaque
            textPopup hideCloseIcon isImageLoaded>
            <ModalOverlay />
            {!!fontStyles && renderModalContent()}
        </FlyUpModal>
    );
}

export default ExhibitTextModal;


